import React, { Component } from 'react';

class SecondaryForm extends Component {
  state = {
    checked: false,
  }

  onCheckboxChange = () => {
    const { checked } = this.state;
    const { setChecked } = this.props;
    setChecked(!checked);
    this.setState(() => ({ checked: !checked }));
  }

  onSubmit = (e) => {
    e.preventDefault();
  };

  render() {
    const { result, spare, resetApp } = this.props;
    const { checked } = this.state;
    return (
      <form className="secondary-form" onSubmit={this.onSubmit}>
        <div>
          <div className="secondary-form__item">
            <label className="form-label" htmlFor="interest">Úroková sadzba v %</label>
            <input
              className="form-input"
              id="interest"
              readOnly
              required
              value={result.interest}
            />
          </div>
          <div className="secondary-form__item">
            <label className="form-label" htmlFor="credit-years">Dĺžka úveru v rokoch</label>
            <input
              className="form-input"
              id="credit-years"
              readOnly
              required
              type="text"
              value={result.creditYears}
            />
          </div>
          <div className="secondary-form__item">
            <label className="form-label" htmlFor="creadit-value">Výška úveru v EUR</label>
            <input
              className="form-input"
              id="credit-value"
              readOnly
              required
              value={result.vyskaUveru}
            />
          </div>
        </div>
        <button onClick={resetApp} className="btn btn--calculate btn--submited" type="submit">Vypočítať Znova</button>
        <div className="checkbox-group">
          <div className="checkbox-group__wrapper">
            {spare
              ? (
                <div className="checkbox-group__wrapper">
                  <input type="checkbox" className="checkbox-group__input" checked={checked} onChange={this.onCheckboxChange} id="large" name="size" />
                  <label htmlFor="large" className="checkbox-group__label">
                    <span className="checkbox-group__button" />
                    <p className="checkbox-group__text">V zmysle Zákona č. 122/2013 Z.z. o ochrane osobných údajov v znení neskorších predpisov súhlasim so správou, spracovaním a uchovaním osobných údajov.</p>
                  </label>
                </div>
              ) : null}
          </div>
        </div>
      </form>
    );
  }
}

export default SecondaryForm;
